module.exports = __webpack_public_path__ + "static/media/WEX-MATIC.8d38b5ef.png";